/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAppointmentTypeResponse } from './GetAppointmentTypeResponse';
import {
    GetAppointmentTypeResponseFromJSON,
    GetAppointmentTypeResponseFromJSONTyped,
    GetAppointmentTypeResponseToJSON,
    GetAppointmentTypeResponseToJSONTyped,
} from './GetAppointmentTypeResponse';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { PriceType } from './PriceType';
import {
    PriceTypeFromJSON,
    PriceTypeFromJSONTyped,
    PriceTypeToJSON,
    PriceTypeToJSONTyped,
} from './PriceType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { AppointmentAvailabilitySlotResponse } from './AppointmentAvailabilitySlotResponse';
import {
    AppointmentAvailabilitySlotResponseFromJSON,
    AppointmentAvailabilitySlotResponseFromJSONTyped,
    AppointmentAvailabilitySlotResponseToJSON,
    AppointmentAvailabilitySlotResponseToJSONTyped,
} from './AppointmentAvailabilitySlotResponse';

/**
 * 
 * @export
 * @interface AppointmentAvailabilityVariantResponse
 */
export interface AppointmentAvailabilityVariantResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    variantId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    participantCount: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    duration: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    price: number;
    /**
     * 
     * @type {PriceType}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    priceType: PriceType;
    /**
     * 
     * @type {GetAppointmentTypeResponse}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    appointmentType: GetAppointmentTypeResponse | null;
    /**
     * 
     * @type {Array<AppointmentAvailabilitySlotResponse>}
     * @memberof AppointmentAvailabilityVariantResponse
     */
    slots: Array<AppointmentAvailabilitySlotResponse>;
}



/**
 * Check if a given object implements the AppointmentAvailabilityVariantResponse interface.
 */
export function instanceOfAppointmentAvailabilityVariantResponse(value: object): value is AppointmentAvailabilityVariantResponse {
    if (!('variantId' in value) || value['variantId'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('priceType' in value) || value['priceType'] === undefined) return false;
    if (!('appointmentType' in value) || value['appointmentType'] === undefined) return false;
    if (!('slots' in value) || value['slots'] === undefined) return false;
    return true;
}

export function AppointmentAvailabilityVariantResponseFromJSON(json: any): AppointmentAvailabilityVariantResponse {
    return AppointmentAvailabilityVariantResponseFromJSONTyped(json, false);
}

export function AppointmentAvailabilityVariantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAvailabilityVariantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'variantId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['variantId']),
        'participantCount': ApiUserTasksGetPageParameterFromJSON(json['participantCount']),
        'duration': json['duration'],
        'price': json['price'],
        'priceType': PriceTypeFromJSON(json['priceType']),
        'appointmentType': GetAppointmentTypeResponseFromJSON(json['appointmentType']),
        'slots': ((json['slots'] as Array<any>).map(AppointmentAvailabilitySlotResponseFromJSON)),
    };
}

export function AppointmentAvailabilityVariantResponseToJSON(json: any): AppointmentAvailabilityVariantResponse {
    return AppointmentAvailabilityVariantResponseToJSONTyped(json, false);
}

export function AppointmentAvailabilityVariantResponseToJSONTyped(value?: AppointmentAvailabilityVariantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variantId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['variantId']),
        'participantCount': ApiUserTasksGetPageParameterToJSON(value['participantCount']),
        'duration': value['duration'],
        'price': value['price'],
        'priceType': PriceTypeToJSON(value['priceType']),
        'appointmentType': GetAppointmentTypeResponseToJSON(value['appointmentType']),
        'slots': ((value['slots'] as Array<any>).map(AppointmentAvailabilitySlotResponseToJSON)),
    };
}

